import { Link } from "react-router-dom";
import { getArticlesForHomepage } from "@/mocks/articles";

export default function BlogSection() {
  const articles = getArticlesForHomepage();

  return (
    <section id="blog" className="w-full py-16 md:py-24 bg-background-100">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-12">
          <p className="text-xs md:text-sm font-medium text-foreground-500 tracking-[0.15em] uppercase mb-3 whitespace-nowrap">
            SEO Guides &amp; Articles
          </p>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-[1.15]">
            ItaobuySpreadsheet
            <br />
            Knowledge Base
          </h2>
          <p className="text-base text-foreground-600 mt-4 max-w-xl mx-auto leading-relaxed">
            Expert guides and tips to help you master product sourcing with the itaobuy spreadsheet system.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {articles.map((article) => (
            <Link
              key={article.slug}
              to={`/guides/${article.slug}`}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/50 hover:border-accent-200 transition-all duration-300 cursor-pointer flex flex-col"
            >
              <div className="relative w-full h-44 overflow-hidden bg-background-200">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-3 py-1 text-xs font-medium bg-background-50/90 text-foreground-700 rounded-full whitespace-nowrap">
                    {article.category}
                  </span>
                </div>
              </div>
              <div className="p-5 flex flex-col flex-1">
                <h3 className="text-sm font-semibold text-foreground-950 mb-2 line-clamp-2 leading-snug group-hover:text-accent-600 transition-colors">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed mb-4 line-clamp-2 flex-1">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between">
                  <span className="text-xs text-foreground-400 whitespace-nowrap">{article.date}</span>
                  <span className="text-xs font-medium text-accent-500 group-hover:text-accent-600 transition-colors whitespace-nowrap flex items-center gap-1">
                    Read Article
                    <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}